/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Self_Organize_TipInputs */



/**
* | output |
* | --- |
* | "Gather 4 or 5 registered players and start your own table — no organizer needed." |
*
* @param {Self_Organize_TipInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_tip = /** @type {((inputs?: Self_Organize_TipInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_TipInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réunissez 4 ou 5 joueurs inscrits et commencez votre propre table — aucun organisateur nécessaire.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reúna 4 o 5 jugadores inscritos y empiece su propia mesa — no necesita organizador.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reúna 4 ou 5 jogadores inscritos e inicie sua própria mesa — sem necessidade de organizador.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riunite 4 o 5 giocatori iscritti e avviate il vostro tavolo — nessun organizzatore necessario.")
	return /** @type {LocalizedString} */ ("Gather 4 or 5 registered players and start your own table — no organizer needed.")
});